import { render, staticRenderFns } from "./MonitorDeGlosa.vue?vue&type=template&id=661034a0"
import script from "./MonitorDeGlosa.vue?vue&type=script&lang=js"
export * from "./MonitorDeGlosa.vue?vue&type=script&lang=js"
import style0 from "./MonitorDeGlosa.vue?vue&type=style&index=0&id=661034a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports